import PropTypes from "prop-types";

const PropTypePrimaryLink = {
  callback: PropTypes.func,
  icon: PropTypes.shape({ svg: PropTypes.string }),
  colorScheme: PropTypes.string,
  isDisabled: PropTypes.bool,
  internalLink: PropTypes.any,
  externalLink: PropTypes.any,
  transition: PropTypes.any,
  buttonText: PropTypes.string,
};
export default PropTypePrimaryLink;
